<wm-email-editor
  #emailEditor
  [form]="form"
  [activity]="activity"
  [emailModel]="activity.model"
  [workflow]="workflow"
  [workflowVersionId]="workflowVersionId"
  [targetClientId]="targetClientId"
  [globalTarget]="globalTarget"
  [loadFull]="loadFull"
  [viewInModal]="viewInModal"
  [showEmailFooterManagementLink]="showEmailFooterManagementLink"
  [hideHeader]="hideHeader"
></wm-email-editor>
